module.exports = __webpack_public_path__ + "static/media/HeadsTogether.cdae015c.png";